const defaultOptions = {
  typeSpeed: 10,
  startDelay: 0,
  backSpeed: 5,
  smartBackspace: true,
  shuffle: false,
  backDelay: 2000,
  loop: false,
  loopCount: false,
  showCursor: false,
  cursorChar: "|",
  contentType: "html",
};

function getTypedOptions(options = {}) {
  const newOptions = { ...defaultOptions, ...options };
  return newOptions;
}

export { getTypedOptions as default };
